import { getPublicUrl } from "../../helpers/getPublicUrl";


export default function ErasmusMain() {
    const downloadDocx = (fileName, name)=> () => {
        const publicUrl = getPublicUrl()
        const docxUrl = publicUrl + `/erasmus/${fileName}`; // If stored in public
        const link = document.createElement("a");
        link.href = docxUrl;
        link.setAttribute("download", `${name}.docx`); // Set download attribute
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    const erasmusPrograms = [
        {
            name: "Lucian Blaga University-Sibiu",
            link: "lucian.docx"
        },
        {
            name: "Polytechnic Institute of Tomar",
            link: "polytechnic.docx"
        },
        {
            name: "The Universidad de León (Staff mobility)",
            link: "staff.docx"
        },
        {
            name: "The Universidad de León (Student mobility)",
            link: "student.docx"
        }
    ]


    return (
        <div className="container">
            <div className="row pt---50 pb---50">
                {erasmusPrograms.map(programs=> (
                    <div className="col-lg-6 mb---30">
                    <p className="lead m-0 text-black">{programs.name}</p>
                    <button className="btn link-primary pl---0" onClick={downloadDocx(programs.link, programs.name)}>
                        Dasturni yuklash <i className="fa fa-download"></i>
                    </button>
            </div>
          ))}
          </div>
          {/*<div className="col-lg-6">*/}
          {/*  <p>IPU 1-101-xona</p>*/}
          {/*  <iframe width="560" height="315" src="https://www.youtube.com/embed/5sOar1cEttg?si=CgOH8PR4i0r5eBdz"*/}
          {/*          title="YouTube video player" frameBorder="0"*/}
          {/*          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
          {/*          referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
          {/*</div>*/}
          {/*<div className="col-lg-6">*/}
          {/*  <p>IPU 1-306-xona</p>*/}

          {/*  <iframe width="560" height="315" src="https://www.youtube.com/embed/hvft2GdDpoQ?si=F63l0eJyRUFhQ3G0"*/}
          {/*          title="YouTube video player" frameBorder="0"*/}
          {/*          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
          {/*          referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}

          {/*</div>*/}
        </div>
    )
}